import {useQuery} from "@tanstack/react-query";
import {trpc} from "@/app/trpc";
import {StickyHeader, Tab, YStack, Button, Loader} from "@chayka/ui";
import {TabGroup, TabList, TabPanel, TabPanels} from "@headlessui/react";
import {List, Calendar} from "./components";
import {useNavigate} from "react-router-dom";
import {SchedulePage} from "../Schedule";
import {useAuth} from "@/hooks/useAuth";

export const MyBookingsPage = () => {
  const {data, isFetching} = useQuery(trpc.booking.list.queryOptions({}));
  const {user} = useAuth();

  const navigate = useNavigate();

  if (user?.confirmationStatus !== "approved") {
    return <SchedulePage />;
  }

  if (!data?.length && !isFetching) {
    return (
      <>
        <StickyHeader title="Мои бронирования" />
        <YStack className="flex-1 justify-center items-center gap-4 pt-[25vh]">
          <h1 className="text-2xl font-light">Тут пока пусто</h1>
          <div className="text-sm text-secondary-text">У вас ещё нет бронирований</div>
          <Button className="self-stretch" onClick={() => navigate("/app/booking")}>
            Забронировать
          </Button>
        </YStack>
      </>
    );
  }

  if (isFetching) {
    return (
      <>
        <StickyHeader title="Мои бронирования" />
        <div className="flex-1 flex justify-center items-center">
          <Loader />
        </div>
      </>
    );
  }

  return (
    <>
      <StickyHeader title="Мои бронирования" />
      <TabGroup className="flex flex-col gap-4">
        <TabList className="flex flex-row gap-2">
          <Tab>Список</Tab>
          <Tab>Календарь</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <List data={data} />
          </TabPanel>
          <TabPanel>
            <Calendar data={data} />
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </>
  );
};
